import React, { Component } from "react";
import Window from "../../2/Controls/Window";
import EmployeeAccess from "./EmployeeAccess";
import EmployeeServiceMapping from "./EmployeeServiceMapping";
import { exportFile } from "../../../actions/DataExporter";
import ExportButton from "../../2/Controls/ExportButton";
import ListingPage from "../../2/Controls/ListingPage";
import AddAttendance from "../../Attendance/AddAttendance";
import AddEditEmployee from "./AddEditEmployee";
import Input from "../../2/Controls/Input";

class StaffList extends Component {

    constructor(props) {

        super(props);

        this.state = {

            list: [],
            totalCount: 0,
            loading: false,

            page: 1,
            pageSize: 25,

            searchParam: "",

            filter: {

                store: "",
                employeeCode: "",
                firstName: "",
                lastName: "",
                emailId: "",
                phoneNo: "",
                status: "active"

            },

            showFilter: false,
            showOption: false,
            showDelete: false,
            showAddStaff: false,
            showEmployeeSystemAccess: false,
            showEmployeeservicemapping: false,

            selectedRow: null,

            isFilterActive: false,

            listPageSettings: {

                Title: "Staff",

                Search: {

                    showSearch: true,

                    placeholder: "Search by employee name, code, email id, contact no",

                    onSearch: (text) => this.onSearch(text),

                    onRefresh: () => this.onRefreshClick(),

                    onFilterClick: () => this.setState({ showFilter: true }),

                    isFilterActive: false

                },

                HeaderButtons: [

                    {

                        ButtonType: "Button",
                        Type: "primary",
                        Text: "New",
                        Icon: "add",
                        Action: "new"

                    },

                    {

                        ButtonType: "ImageButton",
                        Type: "option",
                        Text: "Options",
                        Icon: "option",
                        Action: "options"

                    }

                ],

                Columns: [

                    {
                        Name: "Name",
                        Type: "multiple",
                        ShowInMobile: true,
                        Columns: [
                            {
                                Type: "concatenate",
                                Columns: [
                                    { Column: "EmployeeFirstName" },
                                    { Column: "EmployeeLastName" }
                                ]
                            },
                            { Column: "EmployeeCode", Label: "Code" },
                            { Column: "PhoneNo" },
                            { Column: "EmailID" }
                        ]
                    },

                    {

                        Name: "Employee Code",
                        Type: "field",
                        Columns: [{ Column: "EmployeeCode" }]

                    },

                    {

                        Name: "Name",
                        Type: "concatenate",
                        Columns: [

                            { Column: "EmployeeFirstName" },

                            { Column: "EmployeeLastName" }

                        ]

                    },

                    {

                        Name: "Email ID",
                        Type: "field",
                        Columns: [{ Column: "EmailID" }]

                    },

                    {

                        Name: "Phone No",
                        Type: "field",
                        Columns: [{ Column: "PhoneNo" }]

                    },

                    {

                        Name: "Address",
                        Type: "multiple",
                        Columns: [

                            { Column: "Address1" },
                            { Column: "Address2" },
                            { Column: "City" },
                            { Column: "State" },
                            { Column: "PostalCode" },
                            { Column: "Country" }

                        ]

                    },

                    {

                        Name: "System Access",
                        Type: "multiple",
                        Columns: [

                            { Column: "Role" },
                            { Column: "StoresDisplay" }

                        ]

                    }

                ],

                RowButtons: [

                    {
                        ButtonType: "ImageButton", Type: "edit", Icon: "edit", condition: (row) =>
                            row.hasOwnProperty("IsDeleted") &&
                            row.IsDeleted==false
                    },

                    { ButtonType: "ImageButton", Type: "lock", Icon: "lock",condition: (row) =>
                            row.hasOwnProperty("IsDeleted") &&
                            row.IsDeleted==false },

                    { ButtonType: "ImageButton", Type: "list", Icon: "list" ,condition: (row) =>
                           row.hasOwnProperty("IsDeleted") &&
                            row.IsDeleted==false },

                    { ButtonType: "ImageButton", Type: "delete", Icon: "delete" ,condition: (row) =>
                           row.hasOwnProperty("IsDeleted") &&
                            row.IsDeleted==false }

                ]

            }

        };

    }

    componentDidMount() {

        this.loadData();

    }

    // ================= LOAD DATA =================

    onHeaderButtonClicked = (btn) => {

        if (btn.Action === "new") {


            this.setState({

                showAddStaff: true,
                selectedRow: null

            });

        }

        if (btn.Action === "options") {

            this.setState({

                showOption: true

            });

        }

    };
    loadData = async () => {

        this.setState({ loading: true });

        try {

            const { page, pageSize, filter, searchParam } = this.state;

            const res = await this.props.getEmployees(

                this.props.user.user.RegistrationID,

                filter.store || this.props.user.store.key,

                (page - 1) * pageSize,

                pageSize,

                filter.status,

                searchParam,

                "", "", "", "", "", "", "", "", "", "", "",

                filter.firstName,

                filter.lastName,

                filter.phoneNo,

                filter.emailId,

                filter.employeeCode

            );

            let list = [];

            let totalCount = 0;

            if (res && res.searchResult) {

                list = res.searchResult;

            }

            for (let i = 0; i < list.length; i++) {

                let data = list[i];

                let stores = "";

                data.Role = "";

                if (data.UID) {

                    let user = await this.props.getUserDetails(data.UID);

                    if (user) {

                        data.Role = user.Role;

                        data.Stores = user.Stores;

                    }

                    if (data.Stores) {

                        data.Stores.map((store, index) => {

                            stores += (index > 0 ? "," : "") + store.StoreName;

                            return null;

                        });

                    }

                    data.StoresDisplay = stores;

                }

                list[i] = data;

            }

            if (this.props.user.user.Role !== "Power User") {

                list = list.filter(f => f.Role !== "Power User");

            }

            if (res && res.totalItemsCount) {

                totalCount = res.totalItemsCount;

            }

            this.setState({

                list,
                totalCount,
                loading: false

            });

        }
        catch (error) {

            console.log(error);

            this.setState({ loading: false });

        }

    };

    // ================= SEARCH =================

    onSearch = (text) => {

        this.setState({

            searchParam: text,
            page: 1

        }, this.loadData);

    };

    onRefreshClick = () => {

        this.setState({

            filter: {

                store: "",
                employeeCode: "",
                firstName: "",
                lastName: "",
                emailId: "",
                phoneNo: "",
                status: "active"

            },

            page: 1,

            isFilterActive: false

        }, this.loadData);

    };

    // ================= FILTER =================

    onApplyFilter = () => {

        this.setState({

            page: 1,
            showFilter: false,
            isFilterActive: true

        }, this.loadData);

    };

    onClearFilter = () => {

        this.onRefreshClick();

        this.setState({

            showFilter: false

        });

    };

    // ================= ROW BUTTON =================

    onRowButtonClicked = (btn, row) => {

        if (btn.Type === "edit") {

            this.setState({

                showAddStaff: true,
                selectedRow: row

            });

        }

        if (btn.Type === "lock") {

            this.setState({

                showEmployeeSystemAccess: true,
                selectedRow: row

            });

        }

        if (btn.Type === "list") {

            this.setState({

                showEmployeeservicemapping: true,
                selectedRow: row

            });

        }

        if (btn.Type === "delete") {

            this.setState({

                showDelete: true,
                selectedRow: row

            });

        }

    };

    // ================= DELETE =================

    deleteRecord = async () => {

        const { selectedRow } = this.state;

        if (selectedRow.Role === "Power User") {

            let powerUsers = this.state.list.filter(

                f => !f.IsDeleted && f.Role === "Power User"

            );

            let ctr = powerUsers.filter(

                f => f.key !== selectedRow.key

            ).length;

            if (ctr === 0) {

                alert("Power User cannot be deleted");

                return;

            }

        }
        this.setState({

            showDelete: false,
            loading: true

        }, );
        await this.loadData


        await this.props.deleteEmployee(selectedRow.key);
        this.props.getToastr("Employee deleted successfully");
        await new Promise(resolve => setTimeout(resolve, 3000));



        this.setState({

            showDelete: false,
            selectedRow: null,
            loading: false

        });

        await this.loadData;

    };

    // ================= EXPORT =================

    getExportData = async () => {

        const { filter, searchParam } = this.state;

        const res = await this.props.getEmployees(

            this.props.user.user.RegistrationID,

            filter.store || this.props.user.store.key,

            0,

            10000,

            filter.status,

            searchParam,

            "", "", "", "", "", "", "", "", "", "", "",

            filter.firstName,

            filter.lastName,

            filter.phoneNo,

            filter.emailId,

            filter.employeeCode

        );

        if (res && res.searchResult) {

            let list = [...res.searchResult];

            for (let i = 0; i < list.length; i++) {

                let data = { ...list[i] };

                data.Role = "";
                data.StoresDisplay = "";

                if (data.UID) {

                    const user = await this.props.getUserDetails(data.UID);

                    if (user) {

                        data.Role = user.Role || "";

                        if (user.Stores && user.Stores.length > 0) {

                            data.StoresDisplay = user.Stores
                                .map(store => store.StoreName)
                                .join(",");

                        }

                    }

                }

                list[i] = data;

            }

            if (this.props.user.user.Role !== "Power User") {

                list = list.filter(item => item.Role !== "Power User");

            }

            return list;

        }

        return [];

    };

    handleExport = async (type) => {

        this.setState({ loading: true });

        try {

            const data = await this.getExportData();

            if (!data.length) {

                alert("No data found");

                return;

            }

            const columns = [

                { header: "Employee Code", field: "EmployeeCode" },

                { header: "First Name", field: "EmployeeFirstName" },

                { header: "Last Name", field: "EmployeeLastName" },

                { header: "Email", field: "EmailID" },

                { header: "Phone", field: "PhoneNo" },

                { header: "Role", field: "Role" },

                { header: "Store", field: "StoresDisplay" },
                { header: "UID", field: "UID" },

            ];

            await exportFile({

                data,
                columns,
                fileType: type,
                title: "Staff",
                landscape: true

            });

        }
        catch (error) {

            console.log(error);

            alert("Export failed");

        }
        finally {

            this.setState({ loading: false });

        }

    };

    // ================= RENDER =================
    onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

    render() {

        const f = this.state.filter;

        return (

            <>

                <ListingPage

                    {...this.props}

                    listPageSettings={{

                        ...this.state.listPageSettings,

                        Search: {

                            ...this.state.listPageSettings.Search,

                            isFilterActive: this.state.isFilterActive

                        }

                    }}

                    list={this.state.list}

                    loading={this.state.loading}

                    totalItemsCount={this.state.totalCount}

                    recordFrom={(this.state.page - 1) * this.state.pageSize}

                    itemsCountPerPage={this.state.pageSize}
onPageChange={this.onPageChange}
                    onRowButtonClicked={this.onRowButtonClicked}
                    onHeaderButtonClicked={this.onHeaderButtonClicked}
                />

                {this.state.showFilter && (

                    <Window

                        header="Filter"

                        size="small"

                        slide

                        onClose={() => this.setState({ showFilter: false })}

                        onButtonClick={(action) => {

                            if (action === "Apply") this.onApplyFilter();

                            if (action === "Clear") this.onClearFilter();

                        }}

                        buttons={[

                            { Type: "secondary", Text: "Clear", Align: "left" },

                            { Type: "primary", Text: "Apply", Align: "right" }

                        ]}

                    >

                        <Input
                            type="select"
                            label="Store"
                            value={f.store}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, store: v }
                                })
                            }
                        >

                            <option value="">All</option>

                            {this.props.config.UserStores.map(s => (

                                <option value={s.key}>{s.StoreName}</option>

                            ))}

                        </Input>

                        <Input
                            type="text"
                            label="Employee Code"
                            value={f.employeeCode}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, employeeCode: v }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="First Name"
                            value={f.firstName}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, firstName: v }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="Last Name"
                            value={f.lastName}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, lastName: v }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="Email ID"
                            value={f.emailId}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, emailId: v }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="Phone No"
                            value={f.phoneNo}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, phoneNo: v }
                                })
                            }
                        />

                        <Input
                            type="select"
                            label="Status"
                            value={f.status}
                            onChange={(v) =>
                                this.setState({
                                    filter: { ...f, status: v }
                                })
                            }
                        >

                            <option value="active">Active</option>

                            <option value="inactive">Inactive</option>

                            <option value="all">All</option>

                        </Input>

                    </Window>

                )}

                {this.state.showOption && (

                    <Window

                        header="Options" choiceList

                        size="small"

                        slide

                        onClose={() => this.setState({ showOption: false })}

                    >

                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <ExportButton
                                onExport={this.handleExport}
                                loading={this.state.loading}
                            />
                        </div>

                    </Window>

                )}

                {this.state.showAddStaff && (

                    <AddEditEmployee

                        {...this.props}

                        employee={this.state.selectedRow}

                        onSave={() => {

                            this.setState({ showAddStaff: false }, () => this.loadData());

                        }}

                        onClose={() => this.setState({ showAddStaff: false })}

                    />

                )}

                {this.state.showEmployeeSystemAccess && (

                    <EmployeeAccess

                        {...this.props}

                        employee={this.state.selectedRow}

                        onSave={() => {

                            this.setState({

                                showEmployeeSystemAccess: false

                            }, () => this.loadData());

                        }}

                        onClose={() => this.setState({

                            showEmployeeSystemAccess: false

                        })}

                    />

                )}

                {this.state.showEmployeeservicemapping && (

                    <EmployeeServiceMapping

                        {...this.props}

                        employee={this.state.selectedRow}

                        onSave={() => {

                            this.setState({

                                showEmployeeservicemapping: false

                            }, () => this.loadData());

                        }}

                        onClose={() => this.setState({

                            showEmployeeservicemapping: false

                        })}

                    />

                )}


                {this.state.showDelete && (

                    <Window

                        header="Delete"

                        modal

                        onClose={() => this.setState({ showDelete: false })}

                        onButtonClick={(btn) => {

                            if (btn === "Yes")
                                this.deleteRecord();
                            else
                                this.setState({ showDelete: false });

                        }}

                        buttons={[

                            { Type: "secondary", Text: "No", Align: "left" },

                            { Type: "primary", Text: "Yes", Align: "right" }

                        ]}

                    >

                        Are you sure you want to delete?

                    </Window>

                )}

            </>

        );

    }

}

export default StaffList;